export const iconFontAwesomeChildhoodBucket = (
	<i className="fa-solid fa-bucket"></i>
);
